import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})

export class EstimatedFeeService {
    constructor() {}

    public calculateEstimatedFees(propertyValue: number, isAuctioned: boolean) : EstimatedFees {
        let estimatedFees = new EstimatedFees();

        estimatedFees.notaryExpenses = this.calculateNotaryExpenses(propertyValue);
        estimatedFees.propertyTransferTax = this.calculatePropertyTransferTax(propertyValue);
        estimatedFees.contractRegistration = this.calculateContractRegistrationFee(propertyValue);
        estimatedFees.realEstateAgencyFee = this.calculateRealEstateAgencyFee(propertyValue);
        estimatedFees.legalDueDiligence = this.calculateLegalDueDiligence();
        estimatedFees.otherNotaryExpenses = this.calculateOtherNotaryExpenses(isAuctioned);
        estimatedFees.otherAuctionExpenses = this.calculateOtherAuctionExpenses(isAuctioned);
        estimatedFees.auctionRemovalAndRegistrationExpenses = this.calculateAuctionRemovalAndRegistrationExpenses(isAuctioned);

        return estimatedFees;
    }

    private calculateNotaryExpenses(propertyValue: number): EstimatedFee {
        let percentage = 0;
        if (propertyValue <= 120000) {
            percentage = 0.80;
        } else if (propertyValue <= 380000) {
            percentage = 0.70;
        } else if (propertyValue <= 2000000) {
            percentage = 0.65;
        } else if (propertyValue <= 5000000) {
            percentage = 0.55;
        } else if (propertyValue <= 8000000) {
            percentage = 0.50;
        } else if (propertyValue <= 10000000) {
            percentage = 0.40;
        } else if (propertyValue <= 12000000) {
            percentage = 0.30;
        } else {
            percentage = 0.25;
        }
        let vat = 24 / 100;
        let notaryExpense = (propertyValue * percentage / 100);
        // According to the bug #39365, the static calculations are required to be displayed for now.
        // let totalfee = notaryExpense + (notaryExpense * vat);
        let totalfee = notaryExpense * 1.24 + 20 * 1.24 + 14 * 5 * 1.24 + 10;
        
        return new EstimatedFee(totalfee, percentage);
    }
    
    private calculatePropertyTransferTax(propertyValue: number): EstimatedFee {
        let percentage = 3;
        let tax = (propertyValue * percentage / 100);
        let municipalityFee = (tax * percentage / 100);
        let totalFee = tax + municipalityFee;

        return new EstimatedFee(totalFee, percentage);
    }

    private calculateContractRegistrationFee(propertyValue: number): EstimatedFee {
        let percentage = 0.475;
        let vat = 24 / 100;
        let contractRegistrationFee = (propertyValue * percentage / 100);
        let totalFee = contractRegistrationFee + (contractRegistrationFee * vat);

        return new EstimatedFee(totalFee, percentage)
    }
    
    private calculateRealEstateAgencyFee(propertyValue: number): EstimatedFee {
        let percentage = 2;
        let vat = 24 / 100;
        let realEstateAgencyFee = (propertyValue * percentage / 100);
        let totalFee = realEstateAgencyFee + (realEstateAgencyFee * vat);

        return new EstimatedFee(totalFee, percentage)
    }

    private calculateLegalDueDiligence(): EstimatedFee {
        let vat = 24 / 100;
        let legalDueDiligence = 200;
        let totalFee = legalDueDiligence + (legalDueDiligence * vat);

        return new EstimatedFee(totalFee, 0)
    }
    
    private calculateOtherNotaryExpenses(isAuctioned: boolean): EstimatedFee {
        return new EstimatedFee(isAuctioned ? 500.0 : 0.0, 0);
    }

    private calculateOtherAuctionExpenses(isAuctioned: boolean): EstimatedFee {
        return new EstimatedFee(isAuctioned ? 300.0 : 0.0, 0);
    }

    private calculateAuctionRemovalAndRegistrationExpenses(isAuctioned: boolean): EstimatedFee {
        return new EstimatedFee(isAuctioned ? 1200.0 : 0.0, 0);
    }
}

export class EstimatedFees {
    notaryExpenses?: EstimatedFee;
    landRegistryFees?: EstimatedFee;
    propertyTransferTax?: EstimatedFee;
    engineerFee?: EstimatedFee;
    lawyerFee?: EstimatedFee;
    realEstateAgencyFee?: EstimatedFee;
    contractRegistration?: EstimatedFee;
    legalDueDiligence?: EstimatedFee;
    otherNotaryExpenses?: EstimatedFee;
    otherAuctionExpenses?: EstimatedFee;
    auctionRemovalAndRegistrationExpenses?: EstimatedFee;

    constructor(
        notaryExpenses?: EstimatedFee,
        landRegistryFees?: EstimatedFee,
        propertyTransferTax?: EstimatedFee,
        engineerFee?: EstimatedFee,
        lawyerFee?: EstimatedFee,
        realEstateAgencyFee?: EstimatedFee,
        contractRegistrationFee?: EstimatedFee,
        legalDueDiligence?: EstimatedFee,
        otherNotaryExpenses?: EstimatedFee,
        otherAuctionExpenses?: EstimatedFee,
        auctionRemovalAndRegistrationExpenses?: EstimatedFee
    ) {
        this.notaryExpenses = notaryExpenses;
        this.landRegistryFees = landRegistryFees;
        this.propertyTransferTax = propertyTransferTax;
        this.engineerFee = engineerFee;
        this.lawyerFee = lawyerFee;
        this.realEstateAgencyFee = realEstateAgencyFee;
        this.contractRegistration = contractRegistrationFee;
        this.legalDueDiligence = legalDueDiligence;
        this.otherNotaryExpenses = otherNotaryExpenses;
        this.otherAuctionExpenses = otherAuctionExpenses;
        this.auctionRemovalAndRegistrationExpenses = auctionRemovalAndRegistrationExpenses;
    }
}

class EstimatedFee {
    fee: number;
    percentage: number;

    constructor(
        fee: number,
        percentage: number
    ) {
        this.fee = fee;
        this.percentage = percentage;
    }
}